import React from 'react'
import { StyledText } from './StyledText'

export const H2 = ({ children, ...props }: any) => (
  <StyledText variant="h2" {...props}>
    {children}
  </StyledText>
)
